import axios from '../utils/axios';

export default function getSeekerLogsSubs(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/user/admin/logs-and-subs`, { params })
        .then(response => {
            // Map the new response structure to match the old structure
            if (response.data && response.data.data) {
                return {
                    data: {
                        success: 1,
                        count: response.data.data.count,
                        data: response.data.data.data
                    }
                };
            }
            return response;
        });
};